export interface ConnectionMeasurements {
  connectionState: string;
  candidateType?: string;
  protocol?: string;
  roundTripTimeMs?: number;
}

export interface ConnectionSummary {
  label: string;
  detail: string;
  tone: 'good' | 'fair' | 'slow' | 'waiting';
}

export function connectionSummary(measurements: ConnectionMeasurements): ConnectionSummary {
  if (measurements.connectionState !== 'connected') {
    return { label: 'Connecting', detail: 'Measuring the direct path…', tone: 'waiting' };
  }

  const protocol = measurements.protocol?.toUpperCase() ?? 'DIRECT';
  const candidate = measurements.candidateType ? ` • ${measurements.candidateType}` : '';
  const latency = measurements.roundTripTimeMs;
  if (latency === undefined) {
    return { label: 'Connected', detail: `${protocol}${candidate}`, tone: 'good' };
  }
  if (latency <= 60) return { label: 'Excellent', detail: `${protocol} • ${latency} ms${candidate}`, tone: 'good' };
  if (latency <= 150) return { label: 'Good', detail: `${protocol} • ${latency} ms${candidate}`, tone: 'good' };
  if (latency <= 300) return { label: 'Fair', detail: `${protocol} • ${latency} ms${candidate}`, tone: 'fair' };
  return { label: 'Slow', detail: `${protocol} • ${latency} ms${candidate}`, tone: 'slow' };
}
